export default __webpack_public_path__ + "static/media/file_example_MP4_480_1_5MG.5f55925d.mp4";